import { render } from "./HeaderTicket.vue?vue&type=template&id=6f799761"
import script from "./HeaderTicket.vue?vue&type=script&lang=js"
export * from "./HeaderTicket.vue?vue&type=script&lang=js"

import "./HeaderTicket.vue?vue&type=style&index=0&id=6f799761&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__